<template>
    <div class="modal upgrade-modal">
        <div
            class="modal-content upgrade-modal-content"
            :class="{'upgrade-modal-content-success': 2 === step }"
        >
            <div
                class="modal-close"
                @click="closeModal"
            >
                <i class="far fa-times" />
            </div>
            <div
                v-if="1 === step"
                class="ugprade-modal-container flex"
            >
                <div class="payment-form">
                    <user-payment-setup
                        :skip-registration="true"
                        :upgrade-user="upgradeUser"
                        @process-to-step="upgradeSuccess"
                    >
                        <template v-slot:header>
                            Upgrade to Fusebox Pro
                        </template>
                        <template v-slot:billing-plans-title>
                            Confirm Your Plan
                        </template>
                        <template v-slot:billing-info-title>
                            Enter your billing info
                        </template>
                    </user-payment-setup>
                </div>
                <div class="product-details">
                    <p class="product-header">
                        Pro Plan includes:
                    </p>
                    <template
                        v-if="groupedProductFeatures"
                    >
                       <div
                            v-for="( product, index ) in products"
                            :key="product.id"
                            class="product"
                        >
                            <p class="product-title">
                                <template v-if="index === 0">
                                    <img src="/images/player_logo.svg" alt="Fusebox">
                                </template>
                                <template v-else>
                                    <img src="/images/transcript_logo.svg" alt="Fusebox">
                                </template>
                                {{ product.name }}
                            </p>
                            <div class="product-lists flex">
                                <template v-for="( featureGroup, groupNumber ) in groupedProductFeatures[index]">
                                    <ul
                                        :key="groupNumber"
                                    >
                                        <li
                                            v-for="feature in featureGroup"
                                            :key="feature.name"
                                        >
                                            {{ feature.name }}
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div
                v-else
                class="upgrade-success"
            >
                <svg-vue class="upgrade-success-image" icon="register-success" />
                <h2>Success!</h2>
                <p>You successfully upgraded to Pro plan</p>
                <base-submit-button
                    class="btn"
                    handle-enter="true"
                    @click="closeModal"
                >
                    Close
                </base-submit-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import UserPaymentSetup from '@/components/Register/UserPaymentSetup.vue';
import modal from '@/mixins/modal';
import toasts from '@/mixins/toasts';

import unsuspendUser from '@/utils/user/unsuspendUser';

export default {
    components: {
        UserPaymentSetup,
    },

    mixins: [modal, toasts],

    props: {
        upgradeUser: {
            type: Boolean,
            default: true,
        },
    },

    data: () => ({
        step: 1,
    }),

    computed: {
        ...mapState([
            'user',
            'products',
        ]),
        ...mapGetters(['groupedProductFeatures']),
    },

    methods: {
        ...mapMutations(['changeUIState']),
        ...mapActions(['updateUser']),

        /**
         * Closes upgrade modal
         *
         */
        closeModal() {
            this.changeUIState({ isUpgradeModalVisible: false });
        },

        /**
         * Finish upgrade
         *
         */
        async upgradeSuccess() {
            const unsuspend = await unsuspendUser(this);
            const update = this.updateUser();

            Promise.all([unsuspend, update])
                .then(() => {
                    this.resetNotificationLayout();
                    this.step = 2;
                })
                .catch(() => {
                    this.toastError({
                        message: {
                            title: 'An error occured, we couldn\'t unsuspend your user account. Please contact us, or try again later',
                        },
                    });
                });
        },

        /** Reset layout for free user */
        resetNotificationLayout() {
            const notificationLayoutElement = document.querySelector('.notificationActive');

            if (notificationLayoutElement) {
                notificationLayoutElement.classList.toggle('notificationActive');
            }

            this.changeUIState({ isSuspended: false });
        },

    },
};
</script>
